import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";

export interface RoutineRecordChangeState {
    requests: {
        state: LoadStateInfo;
        request: RoutineRecordChangeRequest
    }[];
}

const initialState: RoutineRecordChangeState = {
    requests: [],
};
function findRoutineRecordRequest(requests: RoutineRecordChangeState["requests"], payload: RoutineRecordChangeRequest) {
    return requests.find((r) =>
        r.request.classroomId === payload.classroomId &&
        r.request.studentId === payload.studentId &&
        r.request.eventDate === payload.eventDate &&
        r.request.routineId === payload.routineId &&
        r.request.routineItemId === payload.routineItemId
    );
}
export interface RoutineRecordChangeRequest {
    classroomId: string;
    studentId: string;
    eventDate: string;
    routineId: string;
    routineItemId: string;
    routineItemOptionId?: string;
}
export const routineRecordChange = createAsyncThunk(
    "routineRecordChange",
    async (param: RoutineRecordChangeRequest, thunkAPI) => {
        console.debug(`change routine records for classroom ${param.classroomId}, date ${param.eventDate}, student ${param.studentId}, routine item ${param.routineItemId} to option ${param.routineItemOptionId}`);

        const response = await fetch(`${getBackendUrl()}/api/routine-record/change`, {
            method: "POST",
            signal: thunkAPI.signal,
            headers: {
                "Authorization": `Bearer ${getToken()}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(param)
        });

        if (response.ok) {
            return await response.json();
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    },
    // {
    //     condition: (param: RoutineRecordChangeRequest, thunkAPI) => {
    //         const state = thunkAPI.getState() as RootState;
    //         const status = state.routineRecordList;
    //         if (!status || !status.state) {
    //             return true;
    //         }
    //         if (status.state.state == LoadState.NotStarted) {
    //             return true;
    //         }
    //         console.debug(`retrieveRoutineRecordList skipped: ${status.state.state}`);
    //         return false;
    //     }
    // }
);

export const routineRecordChangeSlice = createSlice({
    name: "routineRecordChangeList",
    initialState,
    reducers: {
        clear: (state, action: PayloadAction<RoutineRecordChangeRequest>) => {
            const request = findRoutineRecordRequest(state.requests, action.payload);
            if (request) {
                request.state = notStarted();
                request.request = action.payload;
            } else if (!request) {
                state.requests.push({
                    state: notStarted(),
                    request: action.payload
                });
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(routineRecordChange.pending, (state, action) => {
                const payload = action.meta.arg;
                const request = findRoutineRecordRequest(state.requests, payload);
                if (request) {
                    request.state = loading();
                    request.request = payload;
                } else if (!request) {
                    state.requests.push({
                        state: loading(),
                        request: payload
                    });
                }
            })
            .addCase(routineRecordChange.fulfilled, (state, action) => {
                console.debug(`${action.type}`);
                const payload = action.meta.arg;
                const request = findRoutineRecordRequest(state.requests, payload);
                if (request) {
                    request.state = loaded();
                    request.request = payload;
                }
            })
            .addCase(routineRecordChange.rejected, (state, action) => {
                const payload = action.meta.arg;
                const request = findRoutineRecordRequest(state.requests, payload);
                if (request) {
                    request.state = error(action);
                    request.request = payload;
                }
            });
    },
});

// export const { } = routineRecordListSlice.actions;

export const selectRoutineRecordChange = (state: RootState) => state.routineRecordChange;

export default routineRecordChangeSlice.reducer;
